// extracted by mini-css-extract-plugin
export var body = "styles-module--body--7b56c";
export var btnClose = "styles-module--btn-close--08a09";
export var button = "styles-module--button--2e888";
export var header = "styles-module--header--037b3";
export var hidden = "styles-module--hidden--576a2";
export var modal = "styles-module--modal--5df25";
export var options = "styles-module--options--bed0c";